<template>
  <div class="list-wrap">
    <div class="tile is-parent is-parent-wrap">
      <div class="tile is-5 is-parent">
        <article class="tile is-child box">
          <p class="title">批量生成尺码图</p>
          <router-link class="button is-success margin-right20 width-1" :to="{name:'batchExportSizeImg'}">去生成</router-link>
          <router-link class="button is-primary width-1" :to="{name:'sizeImgList'}">配置标题图</router-link>
        </article>
      </div>
      <div class="tile is-5 is-parent">
        <article class="tile is-child box">
          <p class="title">天猫商品同步后台</p>
          <button class="button is-success margin-right20 width-1" @click="tmallModalShow">同步</button>
          <button class="button is-info margin-right20 width-1" @click="tmallRecordModalShow">记录</button>
          <force-sync :parent-category.sync='parentCategory' :designer-info="tmallData.designerInfo"></force-sync>
          <p class="tips">审核通过商品无法再次同步!</p>
        </article>
      </div>
    </div>
    <div class="tile is-parent">
      <div class="tile is-5 is-parent is-parent-wrap">
        <article class="tile is-child box">
          <p class="title">小红书颜色图片上传 <span class="waring-text"><i>*</i> 单次最多上传50张</span></p>
          <button class="button is-success margin-right20 width-1" id="js_imageUploadBtn">上传图片</button>
          <button class="button is-info width-1" @click="littleRedBookRecordShow">上传记录</button>
          <p class="tips">不判断重复数据，重复图片作为增量数据。商品编辑界面进行处理！!</p>
          <div class="loading" v-if="littleRedBook.loading"></div>
        </article>
      </div>
      <div class="tile is-5 is-parent is-parent-wrap">
        <article class="tile is-child box">
          <p class="title">小红书售后图配置</p>
          <a class="button is-success width-1" href="/admin.php?method=config.view&key=icyAfterSaleImage&type=60">去配置</a>
        </article>
      </div>
    </div>
    <!--天猫商品同步操作弹窗start-->
    <el-dialog :title="tmallData.tmallModal.title" width='80%' :visible.sync="tmallData.tmallModal.visible">
      <p class="title">输入天猫地址</p>
      <div class="tmall-goods-modal block">
        <table class="table is-bordered">
          <thead>
          <tr>
            <th>添加链接</th>
            <th>选择设计师</th>
            <th>类目</th>
            <th>商品信息</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in tmallData.tmallGoodsList" style="padding: 10px 0;">
            <td class="padding-right20" style="width: 160px;">
              <textarea :disabled="item.loading" class="input-goods-textarea textarea" v-model="item.url"></textarea>
            </td>
            <td class="padding-right20 relative" >
                <v-select :disabled="item.loading" v-model='tmallData.tmallGoodsList[index].designer' :options="tmallData.designerInfo" :show-labels=false label="name"
                        :id="index" key="name" @input="updateGoodsDesigner" :taggable="true" placeholder="搜索" ></v-select>
            </td>
            <td class="padding-right20">
                <v-select :options="parentCategory" v-model='tmallData.tmallGoodsList[index].selectedParentCategory' :id="index" :show-labels='false' label='name' key='categoryId' placeholder="搜索" @input="updateParentCategory" ></v-select>
                <v-select :options="item.childCategory" v-model='tmallData.tmallGoodsList[index].selectedChildCategory' :id="index" :show-labels='false' label='name' key='categoryId' placeholder="搜索" @input="updateChildCategory" ></v-select>
            </td>
            <td style="width:120px;text-align: center">
              <div v-if="item.msg">{{item.msg}}</div>
              <template v-else>
                <a class="clearfix" v-if="item.goodsId" :href="`https://ai.ichuanyi.com/ai-admin/#/goodsManagement/goodsEdit?goodsId=${item.goodsId}`">
                  <div class="fleft">
                    <!-- <img :src=" item.picture  | formatServerImage | formatQiniuImage 100"> -->

                    <image-component :image="item.picture" :width="100"></image-component>
                  </div>
                  <div class="fleft goods-name">
                    {{item.name}}
                  </div>
                </a>
                <div v-else="">
                  <div v-if="item.loading">
                    <div class="loading"></div>
                  </div>
                  <div v-else="">
                    <button class="button is-info" @click="tmallGoodsSync(index)">同步</button>
                  </div>
                </div>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="block text-center">
        <el-button type="primary" icon="el-icon-plus" class="width-1" @click="addSyncListForm"></el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="MODAL_CANCEL_EVENT">{{tmallData.tmallModal.canceText}}</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">{{tmallData.tmallModal.okText}}</el-button>
      </div>
    </el-dialog>
    <!--天猫商品同步操作弹窗end-->

    <!--天猫商品同步日志弹窗start-->
    <el-dialog width="940px" :visible.sync="tmallData.tmallRecordModal.visible">
      <div v-if="tmallData.tmallRecordModal.count > 0" class="clearfix fright">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="tmallData.tmallRecordModal.count">
        </el-pagination>
      </div>
      <p class="title">记录</p>
      <table class="table is-bordered">
        <thead>
        <tr>
          <th>编号</th>
          <th>操作人员</th>
          <th>时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in tmallData.tmallRecordModal.tmallRecordList">
          <td class="text-center">{{index}}</td>
          <td class="text-center">{{item.operator}}</td>
          <td class="text-center">{{item.time}}</td>
          <td class="text-center">
            <span>{{item.msg}}</span>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="tmallData.tmallRecordModal.count > 0" class="clearfix">
        <el-pagination
          class='fright'
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="tmallData.tmallRecordModal.count">
        </el-pagination>
      </div>
    </el-dialog>
    <!--天猫商品同步日志弹窗end-->

    <!--小红书颜色图上传日志弹窗start-->
    <el-dialog width="940px" :visible.sync="littleRedBook.visible">
      <div v-if="count > 0" class="clearfix fright">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
      <p class="title">记录</p>
      <table class="table is-bordered">
        <thead>
        <tr>
          <th>编号</th>
          <th>操作人员</th>
          <th>时间</th>
          <th>记录</th>
          <th>错误数据</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in littleRedBook.recordList">
          <td class="text-center">{{item.logId}}</td>
          <td class="text-center">{{item.username}}</td>
          <td class="text-center">{{item.createTime}}</td>
          <td class="text-center">{{item.msg}}</td>
          <td class="text-center">{{item.errMsg}}</td>
          <td class="text-center">
            <a v-if="item.downloadLink" class="button is-danger" @click="doExport($event,item.downloadLink)">错误下载</a>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="count > 0" class="clearfix ">
        <el-pagination
          class='fright'
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </el-dialog>
    <!--小红书颜色图上传日志弹窗end-->
  </div>
</template>
<script type="text/babel">
import VSelect from 'vue-multiselect'
import Uploader from 'COMMON/uploaderModule/uploader'
import ForceSync from './forceSync'
export default {
  components: {
    VSelect, ForceSync
  },
  data () {
    return {
      // 天猫商品同步相关数据
      parentCategory: [],
      parentCategoryChosen: '',
      tmallData: {
        goodsArray: [],
        tmallModal: {
          visible: false,
          okText: '关闭',
          canceText: '去编辑',
          title: '天猫商品同步'
        },
        tmallRecordModal: {
          count: 0,
          visible: false,
          tmallRecordList: []
        },
        tmallGoodsList: [
          {
            url: '',
            designer: {},
            thirdPartyGoodsId: 0, // 同步后用来轮询同步是否成功的id
            goodsId: '',
            loading: false,
            name: '',
            picture: '',
            selectedParentCategory: {},
            selectedChildCategory: {},
            childCategory: [],
            msg: ''
          }
        ],
        designerInfo: [],
        tmallPollingtime: 0
      },
      // 小红书颜色图相关数据
      littleRedBook: {
        visible: false,
        loading: false,
        recordList: [],
        images: []
      },

      page: 1,
      pageSize: 20,
      count: 0
    }
  },
  mounted () {
    this.getDesignerInfo()
    this.uploadMainBind()
  },
  methods: {
    handleCurrentChange (value) {
      if (this.page !== value) {
        this.page = value
        if (this.tmallData.tmallRecordModal.visible) { // 天猫商品同步记录
          this.tmallRecordModalGet()
        } else {
          this.littleRedBookRecordGet()
        }
      }
    },
    // 关闭弹窗检查并提示
    MODAL_OK_EVENT () {
      let count = 0
      _.each(this.tmallData.tmallGoodsList, (item, index) => {
        if (item.thirdPartyGoodsId) {
          count++
        }
      })
      if (count > 0) {
        let mes = '提示：' + count + '商品正在同步，是否继续关闭？（不影响实际抓取）'
        if (confirm(mes)) {
          this.tmallData.tmallModal.visible = false
        }
      } else {
        this.tmallData.tmallModal.visible = false
      }
    },
    // 新打开商品编辑页
    MODAL_CANCEL_EVENT () {
      window.open('https://ai.ichuanyi.com/ai-admin/#/goodsManagement/goodsList')
    },
    updateParentCategory (value, index) {
      this.tmallData.tmallGoodsList[index].selectedParentCategory = value
      HttpRequest.get('/admin.php?method=goods.getCategoryList', {parentCategoryId: value.categoryId}).then(response => {
        this.tmallData.tmallGoodsList[index].childCategory = _.toArray(response.data.list).map((item) => {
          return {
            categoryId: item.categoryId,
            name: item.name
          }
        })
      })
    },
    updateChildCategory (value, index) {
      this.tmallData.tmallGoodsList[index].selectedChildCategory = value
    },

    /** 以下是小红书颜色图上传相关代码**/
    // 导出错误
    doExport (e, downloadLink) {
      e.target.href = downloadLink
    },
    // 上传日志弹窗展示
    littleRedBookRecordShow () {
      this.page = 1
      this.count = 0
      this.littleRedBookRecordGet()
    },
    littleRedBookRecordGet () {
      HttpRequest.get('/admin.php?method=icygoods.getXHSLog', {page: this.page, pageSize: this.pageSize}).then(response => {
        this.littleRedBook.recordList = response.data.list
        this.count = response.data.count * 1
        if (this.page == 1) {
          this.littleRedBook.visible = true
        }
      })
    },
    // 同步颜色图
    doSaveXHSColorImages () {
      HttpRequest.post('/admin.php?method=icygoods.doSaveXHSColorImages', {images: JSON.stringify(this.littleRedBook.images)}).then(response => {
        if (response.data.success) {
          this.littleRedBook.loading = false
          this.littleRedBook.images = []
          this.littleRedBookRecordShow()
        }
      }, (response) => {
        this.littleRedBook.images = []
        if (response.msg) {
          this.$message(response.msg)
          this.littleRedBookRecordShow()
        }
      })
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: true
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileNumLimit: 50,
          fileSizeLimit: 50 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            // 上传开始loading
            this.littleRedBook.loading = true
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            let item = {
              name: response.data.images.info.sourceFileName,
              image: {
                height: response.data.images.info.height,
                width: response.data.images.info.width,
                image: response.data.images.info.path
              }
            }
            this.littleRedBook.images.push(item)
          },
          onFinished (response) {
            this.doSaveXHSColorImages()
            this.littleRedBook.loading = false
          },
          onError (response, file, uploaderObj) {
            this.littleRedBook.loading = false
          }
        }
      }
      new Uploader(params)
    },

    /** 以下是天猫商品同步相关代码**/
    tmallModalShow () {
      if (this.tmallData.goodsArray.length == 0) {
        this.tmallData.tmallGoodsList = [
          {
            url: '',
            designer: {},
            thirdPartyGoodsId: 0, // 同步后用来轮询同步是否成功的id
            goodsId: '',
            loading: false,
            name: '',
            picture: '',
            childCategory: [],
            msg: ''
          }
        ]
      }
      this.tmallData.tmallModal.visible = true
      if (!this.parentCategory.length) {
        HttpRequest.get('/admin.php?method=goods.getCategoryList', {parentCategoryId: 0}).then(response => {
          this.parentCategory = _.toArray(response.data.list).map((item) => {
            return {
              categoryId: item.categoryId,
              name: item.name
            }
          })
        })
      }
    },
    // 天猫商品同步抓取
    tmallGoodsSync (index) {
      if (!this.tmallData.tmallGoodsList[index].url) {
        this.$message('请输入天猫商品链接~')
        return
      }
      if (!this.tmallData.tmallGoodsList[index].designer) {
        this.$message('请选择设计师~')
        return
      }
      if (!this.tmallData.tmallGoodsList[index].selectedParentCategory) {
        this.$message('请选择一级类目~')
        return
      }
      if (!this.tmallData.tmallGoodsList[index].selectedChildCategory) {
        this.$message('请选择二级类目~')
        return
      }
      this.tmallData.tmallGoodsList[index].loading = true
      let urlArray = []
      let item = {
        'url': this.tmallData.tmallGoodsList[index].url,
        'designerId': this.tmallData.tmallGoodsList[index].designer.id
      }
      let params = Object.assign({}, item, {categoryId: this.tmallData.tmallGoodsList[index].selectedParentCategory.categoryId}, {subCategoryId: this.tmallData.tmallGoodsList[index].selectedChildCategory.categoryId})
      HttpRequest.post('/admin.php?method=shoppingguide.doImportChuanYiGoods', params, true).then(response => {
        if (response.data && response.data[0] && response.data[0]['thirdPartyGoodsId']) {
          this.tmallData.tmallGoodsList[index]['thirdPartyGoodsId'] = response.data[0]['thirdPartyGoodsId']
          // 成功后轮训抓取接口
          this.getImportPolling()
        }
      }, (response) => {
        setTimeout(() => {
          let tmallGoodsItem = {
            url: '',
            designer: this.tmallData.tmallGoodsList[index].designer,
            selectedParentCategory: this.tmallData.tmallGoodsList[index].selectedParentCategory,
            selectedChildCategory: this.tmallData.tmallGoodsList[index].selectedChildCategory,
            thirdPartyGoodsId: 0, // 同步后用来轮询同步是否成功的id
            goodsId: '',
            loading: false,
            name: '',
            picture: '',
            msg: ''
          }
          this.tmallData.tmallGoodsList[index] = tmallGoodsItem
          this.$set(this.tmallData, 'tmallGoodsList', JSON.parse(JSON.stringify(this.tmallData.tmallGoodsList)))
        }, 2000)
      })
    },
    // 轮询抓取进度
    getImportPolling () {
      let nameLen = 0
      let goodsIdLen = 0
      let pictureLen = 0
      this.tmallData.setIntervalTime = setInterval(() => {
        this.getImportProcess((response) => {
          _.each(response.data, (item, index) => {
            let _item = _.findWhere(this.tmallData.tmallGoodsList, {thirdPartyGoodsId: item.thirdPartyGoodsId})
            if (_item) {
              _item.name = item.name ? item.name : ''
              _item.goodsId = item.goodsId ? item.goodsId : ''
              _item.picture = item.picture ? item.picture : ''
              _item.msg = item.msg ? item.msg : ''
            }
          })
        })
      }, 3000)
    },
    // 抓取
    getImportProcess (callback) {
      this.tmallData.goodsArray = []
      _.each(this.tmallData.tmallGoodsList, (item, index) => {
        if (!item.msg) {
          if ((item.thirdPartyGoodsId && !item.goodsId && !item.picture)) {
            this.tmallData.goodsArray.push(item.thirdPartyGoodsId)
          }
        }
      })
      if (this.tmallData.goodsArray.length == 0) {
        clearInterval(this.tmallData.setIntervalTime)
      } else {
        HttpRequest.post('/admin.php?method=shoppingguide.getImportProcess', {goodsArray: this.tmallData.goodsArray}).then(response => {
          callback && callback(response)
        })
      }
    },
    // 获取设计师列表
    getDesignerInfo () {
      HttpRequest.get('/admin.php?method=shoppingguide.getDesignerInfo').then(response => {
        if (response && response.data && response.data) {
          this.tmallData.designerInfo = _.toArray(response.data)
        }
      })
    },
    // 所属设计师更新
    updateGoodsDesigner (data, index) {
      if (data) {
        this.tmallData.tmallGoodsList[index].designer = data
      }
    },
    // 添加同步框
    addSyncListForm () {
      this.tmallData.tmallGoodsList.push({
        url: '',
        designerId: {},
        thirdPartyGoodsId: 0, // 同步后用来轮询同步是否成功的id
        goodsId: 0,
        loading: false,
        name: '',
        picture: '',
        childCategory: [],
        msg: ''
      })
    },
    // 展示天猫商品同步记录
    tmallRecordModalShow () {
      this.page = 1
      this.count = 0
      this.tmallRecordModalGet()
    },
    tmallRecordModalGet () {
      HttpRequest.get('/admin.php?method=shoppingguide.getOperationHistory', {page: this.page, pageSize: this.pageSize}).then(response => {
        if (response.data) {
          this.tmallData.tmallRecordModal.tmallRecordList = response.data.list
          this.tmallData.tmallRecordModal.count = Number(response.data.totalNumber)
          if (this.page == 1) {
            this.tmallData.tmallRecordModal.visible = true
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .td-wrap {
    width: 90%;
    height: 100%;
    position: absolute;

  }
  .absolute {
    position: absolute;
  }
  .relative {
    position: relative;
  }
  .is-parent-wrap{
    height: 240px;
    position: relative;
  .loading{
    width: 95%;
    height: 93%;
    background: rgba(255, 255, 255, 0.6);
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
  }
  .loading:after{
    content:"";
    width: 32px;
    height: 32px;
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    background: url("../../styles/images/loading.gif") no-repeat;
  }
  }
  .margin-right20{
    margin-right: 20px;
  }
  .tips{
    position: absolute;
    bottom: 30px;
  }
  .tmall-goods-modal{
    .goods-name{
      width: 180px !important;
      margin-left: 20px;
    }
    .loading{
      width:30px;
      height:30px;
      background-image: url("../../styles/images/loading.gif");
      background-size: 80% 80%;
      background-repeat: no-repeat;
      margin: 0 auto;
    }
    .tmall-goods-list{
      margin-bottom: 20px;
    }
    .input-goods-textarea{
      width: 360px !important;
      min-height: 80px !important;
    }
    .padding-right20{
      padding-right: 20px;
    }
  }
  .waring-text{
    font-size: 14px;
    i{
      color: #ff0000;
    }
  }
  .el-dialog{
    width: 940px;
  }
  .margin-right-50 {
    margin-right: 50px;
  }
  .margin-top-10 {
    margin-top: 10px;
  }
</style>
